import * as React from 'react';
import { observer } from 'mobx-react';
import { translationForMts } from 'easit--localization';
import { CaretExpander, TodayTickets } from 'desktop--design-library';
import { ITodayTicketsStore } from 'eTip--common';

interface ICcashoutForMyTickets {
    id: number;
    value: number;
}

export interface ITodayTicketsProps {
    todayTickets: ITodayTicketsStore;
    cashOutList: ICcashoutForMyTickets[];
    goToTicketDetail: (ticketId: string) => void;
}

@observer
export class TodayTicketsContainer extends React.Component<ITodayTicketsProps> {
    constructor(props: ITodayTicketsProps) {
        super(props);
    }

    get store() {
        return this.props.todayTickets;
    }

    private autoReload() {
        window.setTimeout(() => {
            this.store.loadDataAsync(true, true).then(() => { this.autoReload() });
        }, 30000)
    }

    componentWillMount() {
        this.store.setCashouts(this.props.cashOutList);
        this.store.loadDataAsync(false).then(() => { this.autoReload() });
    }

    componentWillReceiveProps(next: ITodayTicketsProps) {
        this.store.setCashouts(next.cashOutList);
        this.store.setCashoutToTickets();
    }

    render() {
        return (<CaretExpander className="my-2 today-tickets-expander" title={translationForMts().rightColumn_MyBetsToday} isExpanded={true}>
            <TodayTickets
                state={this.store.state}
                tickets={[...this.store.tickets]}
                error={this.store.error}
                showLoadNext={this.store.showLoadNext}

                onGoToDetail={this.props.goToTicketDetail}
                onReload={() => { this.store.loadDataAsync(true) }}
                onLoadNext={() => { this.store.loadNextAsync() }}
            />
        </CaretExpander>)
    }
}